import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-down\"><path d=\"M8 1H7v11.122l-1.975-1.975c0-.003-.354-.353-.707 0-.354.354 0 .707 0 .707L7.5 14.036l3.182-3.182s.354-.354 0-.707c-.33-.33-.66-.04-.703-.004l-.004.004L8 12.122V1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol